<script setup>
import FooterLudwig from '@/Layouts/Partials/FooterLudwig.vue'
import { defineComponent, h } from 'vue'
import { EnvelopeIcon } from '@heroicons/vue/24/outline'

const navigation = {
    main: [
        { name: 'Domů', route_name: 'home' },
        { name: 'Slevy', route_name: 'discounts.index' },
        { name: 'Blog', route_name: 'blogs.index' },
        { name: 'O nás', route_name: 'abouts.index' },
        { name: 'Podat daňové přiznání', route_name: 'orders.create' },
    ],
    social: [
        {
            name: 'Instagram',
            href: 'https://www.instagram.com/priznani_snadno/',
            icon: defineComponent({
                render: () =>
                    h('svg', { fill: 'currentColor', viewBox: '0 0 24 24' }, [
                        h('path', {
                            'fill-rule': 'evenodd',
                            d: 'M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z',
                            'clip-rule': 'evenodd',
                        }),
                    ]),
            }),
        },
        {
            name: 'TikTok',
            href: 'https://www.tiktok.com/@priznani_snadno',
            icon: defineComponent({
                render: () =>
                    h('svg', { fill: 'currentColor', viewBox: '0 0 512 512', xmlns: 'http://www.w3.org/2000/svg' }, [
                        h('path', {
                            d: 'M412.19,118.66a109.27,109.27,0,0,1-9.45-5.5,132.87,132.87,0,0,1-24.27-20.62c-18.1-20.71-24.86-41.72-27.35-56.43h.1C349.14,23.9,350,16,350.13,16H267.69V334.78c0,4.28,0,8.51-.18,12.69,0,.52-.05,1-.08,1.56,0,.23,0,.47-.05.71,0,.06,0,.12,0,.18a70,70,0,0,1-35.22,55.56,68.8,68.8,0,0,1-34.11,9c-38.41,0-69.54-31.32-69.54-70s31.13-70,69.54-70a68.9,68.9,0,0,1,21.41,3.39l.1-83.94a153.14,153.14,0,0,0-118,34.52,161.79,161.79,0,0,0-35.3,43.53c-3.48,6-16.61,30.11-18.2,69.24-1,22.21,5.67,45.22,8.85,54.73v.2c2,5.6,9.75,24.71,22.38,40.82A167.53,167.53,0,0,0,115,470.66v-.2l.2.2C155.11,497.78,199.36,496,199.36,496c7.66-.31,33.32,0,62.46-13.81,32.32-15.31,50.72-38.12,50.72-38.12a158.46,158.46,0,0,0,27.64-45.93c7.46-19.61,9.95-43.13,9.95-52.53V176.49c1,.6,14.32,9.41,14.32,9.41s19.19,12.3,49.13,20.31c21.48,5.7,50.42,6.9,50.42,6.9V131.27C453.86,132.37,433.27,129.17,412.19,118.66Z',
                        }),
                    ]),
            }),
        },
        {
            name: 'YouTube',
            href: 'https://www.youtube.com/@priznanisnadno',
            icon: defineComponent({
                render: () =>
                    h('svg', { fill: 'currentColor', viewBox: '0 0 24 24' }, [
                        h('path', {
                            'fill-rule': 'evenodd',
                            d: 'M19.812 5.418c.861.23 1.538.907 1.768 1.768C21.998 8.746 22 12 22 12s0 3.255-.418 4.814a2.504 2.504 0 0 1-1.768 1.768c-1.56.419-7.814.419-7.814.419s-6.255 0-7.814-.419a2.505 2.505 0 0 1-1.768-1.768C2 15.255 2 12 2 12s0-3.255.417-4.814a2.507 2.507 0 0 1 1.768-1.768C5.744 5 11.998 5 11.998 5s6.255 0 7.814.418ZM15.194 12 10 15V9l5.194 3Z',
                            'clip-rule': 'evenodd',
                        }),
                    ]),
            }),
        },
    ],
}
</script>

<template>
    <footer class="bg-zinc-950">
        <div class="section--width">
            <nav
                class="flex flex-wrap justify-center gap-x-12 gap-y-3 text-sm/6"
                aria-label="Footer"
            >
                <Link
                    v-for="item in navigation.main"
                    :key="item.name"
                    :href="route(item.route_name)"
                    :aria-label="'Odkaz ' + item.name"
                    class="text-gray-400 hover:text-white"
                >
                    {{ item.name }}
                </Link>
            </nav>

            <div class="my-10 flex justify-center gap-x-10">
                <a
                    v-for="item in navigation.social"
                    :key="item.name"
                    :href="item.href"
                    :aria-label="'Odkaz ' + item.name"
                    target="_blank"
                    rel="nofollow noopener"
                    class="text-gray-400 hover:text-gray-300"
                >
                    <span class="sr-only">{{ item.name }}</span>

                    <component
                        :is="item.icon"
                        class="size-6"
                        aria-hidden="true"
                    />
                </a>
            </div>

            <ul class="flex justify-center gap-x-10">
                <li class="text-gray-400 hover:text-gray-300">
                    <a
                        class="inline-flex"
                        href="mailto:podpora@priznanisnadno.cz"
                        target="_blank"
                        rel="nofollow noopener"
                        aria-label="Odkaz na e-mail - podpora@priznanisnadno.cz"
                    >
                        <EnvelopeIcon
                            class="mr-2 size-6"
                            aria-hidden="true"
                        />

                        podpora@priznanisnadno.cz
                    </a>
                </li>

                <li class="text-gray-400 hover:text-gray-300">
                    <a
                        class="inline-flex"
                        href="https://rejstrik-firem.kurzy.cz/22547070/solvecount-sro/statisticky-urad/"
                        target="_blank"
                        rel="nofollow noopener"
                        aria-label="Odkaz na živnostenský list - 19090901"
                    >
                        IČ: 22547070
                    </a>
                </li>
            </ul>

            <hr class="my-16 border-zinc-700" />

            <ul class="flex flex-col items-center justify-center space-y-2 gap-x-10">
                <li
                    target="_blank"
                    rel="nofollow noopener"
                    class="text-gray-400 hover:text-gray-300"
                >
                    <Link
                        class="inline-flex"
                        :href="route('laws.return')"
                        aria-label="Reklamace"
                    >
                        Reklamace
                    </Link>
                </li>
                <li
                    target="_blank"
                    rel="nofollow noopener"
                    class="text-gray-400 hover:text-gray-300"
                >
                    <Link
                        class="inline-flex"
                        :href="route('laws.terms')"
                        aria-label="Obchodní podmínky"
                    >
                        Obchodní podmínky
                    </Link>
                </li>
                <li
                    target="_blank"
                    rel="nofollow noopener"
                    class="text-gray-400 hover:text-gray-300"
                >
                    <Link
                        class="inline-flex"
                        :href="route('laws.policy')"
                        aria-label="Ochrana osobních údajů"
                    >
                        Ochrana osobních údajů
                    </Link>
                </li>
                <li>
                    <button
                        @click="showHideToggleCookiePreferencesModal()"
                        class="text-xs text-gray-200 hover:underline md:text-sm/6"
                        aria-label="Změnit preference souborů cookie"
                    >
                        Změnit preference souborů cookie
                    </button>
                </li>
            </ul>

            <hr class="my-16 border-zinc-700" />

            <ul class="flex items-center justify-center space-y-2 gap-x-10">
                <li
                    v-for="(item, index) in 9"
                    :key="index"
                >
                    <img
                        :src="'/src/footer/' + item + '.png'"
                        alt="Způsob platby"
                        class="aspect-4/5 h-auto w-24 object-contain"
                    />
                </li>
            </ul>

            <hr class="my-16 border-zinc-700" />

            <p class="text-center text-sm/6 text-gray-400">&copy; {{ new Date().getFullYear() }} SolveCount s.r.o.</p>
        </div>

        <div class="relative flex flex-col items-center justify-between pb-6">
            <div class="flex w-full flex-col items-center justify-center space-y-5">
                <FooterLudwig />
            </div>
        </div>
    </footer>
</template>
